module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1643910782-develop/node_modules/recompose/node_modules/symbol-observable/index.js
// module id = 222
// module chunks = 0